import {
    Badge,
    Box,
    Button,
    Flex,
    Grid,
    Group,
    Input,
    Menu,
    MultiSelect,
    MultiSelectProps,
    rem,
    Select,
    Text,
} from "@mantine/core";
import {
    IconBarcode,
    IconBriefcase,
    IconBuildingWarehouse,
    IconCaretDown,
    IconFileExport,
    IconFolders,
    IconListDetails,
    IconMapPin,
    IconSearch,
    IconTimeDuration15,
    IconX,
} from "@tabler/icons-react";
import {
    MRT_ColumnDef,
    MRT_PaginationState,
    MRT_RowSelectionState,
    MantineReactTable,
    useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { useForm } from "@mantine/form";
import { useDebouncedCallback, useDisclosure } from "@mantine/hooks";
import { SelectListItemModel } from "../../../../model/SelectListItem";
import { BASE_API_MDM } from "../../../../config";
import { green } from "../../../../const/variables";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
    repositoryMdm,
    repositoryPos,
    styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import {
    formatDateNotTimeZone,
    formatDateTransfer,
    formatDateTransferLastYear,
    formatToReverseDate,
} from "../../../../common/FormatDate/FormatDate";
import { DatePickerInput } from "@mantine/dates";
import { MessageResponse } from "../../../../model/MessageResponse";
import { ComboboxItem } from "../../../../model/ComboboxItem";

interface SearchCriteria {
    keySearch?: string;
    MaNganh?: string;
    MaNhom?: string;
    MaChung?: string;
}

const InventoryAgeItemGroup = () => {
    // Khởi tạo component InventoryReportList
    const headerRef = React.useRef<HTMLDivElement>(null);
    const [isRefetching, setIsRefetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 20,
    });
    const [visible, { toggle, close, open }] = useDisclosure(false);

    const [height, setHeight] = useState(0);
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
    const [data, setData] = useState<InventoryItem[]>([]);
    const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
    const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
    const [rowCount, setRowCount] = useState(0);
    const [dataCatSegment5e, setDataCatSegment5e] = useState<any[]>([]);
    const [dataCatSegment2b, setDataCatSegment2b] = useState<any[]>([]);
    const [dataCatSegment4d, setDataCatSegment4d] = useState<any[]>([]);
    const form = useForm<SearchCriteria>({
        mode: "uncontrolled",
        initialValues: {},
    });

    type InventoryItem = {
        branchCode: string;
        branchName: string;
        countSoLuong: number;
        dvt: string | null;
        idBranch: number;
        idKho: number;
        maKho: string;
        maSp: string;
        soLuong: number | null;
        tenKho: string;
        tenSp: string;
    };

    const columns = React.useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                header: "STT",
                accessorKey: "STT",
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                Cell: ({ row }) => <>{row?.index + 1}</>,
                size: 50,
            },
            {
                accessorKey: "nganhHang",
                header: "Ngành hàng",
            },
            {
                accessorKey: "loaiHang",
                header: "Loại hàng",
            },
            {
                accessorKey: "chungHang",
                header: "Chủng hàng",
            },
            {
                accessorKey: "giaTriTon",
                header: "Giá trị tồn",
                Cell: ({ renderedCellValue }) => (
                    <>
                        {Number(renderedCellValue).toLocaleString("vi-VN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </>
                ),
            },
            {
                accessorKey: "soLuongTon",
                header: "Số lượng tồn",
                Cell: ({ renderedCellValue }) => (
                    <>
                        {Number(renderedCellValue).toLocaleString("vi-VN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </>
                ),
            },
            {
                accessorKey: "tyTrong",
                header: "Tỷ trọng",
                Cell: ({ renderedCellValue, cell, row }) => <>{renderedCellValue} %</>,
            },
        ],
        []
    );
    const exportDataExcel = async () => {
        open();
        try {
            let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
            const search = form.getValues();
            if (search.MaNhom && search.MaNhom.length > 0) {
                url += `&MaNhom=${search.MaNhom}`;
            }
            if (search.MaNganh && search.MaNganh.length > 0) {
                url += `&MaNganh=${search.MaNganh}`;
            }
            if (search.MaChung && search.MaChung.length > 0) {
                url += `&MaChung=${search.MaChung}`;
            }
            if (search.keySearch) {
                url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
            }
            const baseUrl = `/api/v1/ExportExcel/export-bao-cao-tuoi-ton-theo-nhom-hang${url}`;

            const _url = BASE_API_MDM + baseUrl;
            const token = localStorage.getItem("token");

            const response = await fetch(_url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.ms-excel",
                    Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
                },
            });
            // Kiểm tra trạng thái HTTP
            if (!response.ok) {
                const errorResponse = await response.json(); // Parse lỗi từ API
                const errorMessage =
                    errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
                throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
            }

            const blob = await response.blob();
            const urlss = window.URL.createObjectURL(blob);
            const _name = new Date().toISOString().slice(0, 10);
            let filename = "bao_cao_tuoi_ton_theo_nhom_hang.xlsx";
            const link = document.createElement("a");
            link.href = urlss;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error: any) {
            console.log("error", error);
            // Hiển thị thông báo lỗi
            NotificationExtension.Fails(
                error.message || "Đã xảy ra lỗi không xác định!"
            );
        } finally {
            close();
        }
    };
    // Hàm lấy dữ liệu
    const fetchData = async () => {
        setIsLoading(true);
        setIsRefetching(true);
        setIsError(false);

        let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
            }`;
        const search = form.getValues();
        if (search.MaNhom && search.MaNhom.length > 0) {
            url += `&MaNhom=${search.MaNhom}`;
        }
        if (search.MaNganh && search.MaNganh.length > 0) {
            url += `&MaNganh=${search.MaNganh}`;
        }
        if (search.MaChung && search.MaChung.length > 0) {
            url += `&MaChung=${search.MaChung}`;
        }

        if (search.keySearch) {
            url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
        }
        try {
            const response = await repositoryMdm.get(
                `/api/v1/BaoCaoTuoiTonTheoNhomHang/get-list${url}`
            );
            if (response && response.success) {
                let result = response.data;
                setData(result);
                setRowCount(response.totalCount);
                table.resetRowSelection();
            } else {
                setData([]);
                setRowCount(response.totalCount);
            }
        } catch (error) {
            setData([]);
            setIsError(true);
            console.error(error);
            return;
        } finally {
            setIsLoading(false);
            setIsRefetching(false);
        }
    };
    const getCatSegment4d = async () => {
        let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=50`;
        const res = await repositoryPos.get<MessageResponse<any>>(url);

        if (res && res.success) {
            const data = res.data
                ?.filter((item: any) => item.codeString && item.name)
                ?.map((item: any) => ({
                    label: `${item.codeString} - ${item.name}`,
                    value: item.codeString?.toString(),
                }));

            setDataCatSegment4d(data);
        }
    };

    const getCatSegment5e = async () => {
        let url = `/api/v1/TblCatSegment5e/get-list?Skip=0&Take=50`;
        const search = form.getValues();
        if (search?.MaChung && search?.MaChung?.length > 0) {
            url += `&ListCodeString4=${search?.MaChung}`;
        }
        const res = await repositoryPos.get<MessageResponse<any>>(url);
        if (res && res.success) {
            const data = res.data
                ?.filter((item: any) => item.codeString && item.name)
                ?.map((item: any) => ({
                    label: `${item.codeString} - ${item.name}`,
                    value: item.codeString?.toString(),
                }));

            setDataCatSegment5e(data);
        }
    };
    const fetchDataCatSegment2b = async () => {
        const res = await repositoryPos.get<MessageResponse<any>>(
            "/api/v1/TblCatSegment2b/get-all"
        );

        if (res && res.success) {
            let data: ComboboxItem[] = [];
            data = res.data
                ?.filter(
                    (item: any) => item.codeString && item.name && item.segment1CodeString
                )
                ?.map((item: any) => ({
                    label: `${item.codeString} - ${item.name}`,
                    value: item.codeString?.toString(),
                    segment1CodeString: item.segment1CodeString?.toString(),
                }));

            setDataCatSegment2b(data);
        }
    };
    //   const DataItemCode = async (keySearch: string) => {
    //     try {
    //       let url = "";
    //       if (keySearch && keySearch.length > 0) {
    //         url += `&ItemCodes=${keySearch}`;
    //       }
    //       const response = await repositoryPos.get(
    //         `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`
    //       );
    //       if (response && response.success) {
    //         const transformedData = response.data
    //           ?.filter((i: any) => i.value && i.text)
    //           .map((branch: any) => ({
    //             value: branch.value,
    //             label: branch.text,
    //           }));
    //         const uniqueData = Array.from(
    //           new Set(transformedData.map((item: any) => item.value))
    //         ).map((value) =>
    //           transformedData.find((item: any) => item.value === value)
    //         );
    //         setDataItemCode(uniqueData);
    //       }
    //     } catch (error) {
    //       console.error(error);
    //       return;
    //     }
    //   };

    const table = useMantineReactTable({
        columns,
        data,
        enableColumnResizing: true,
        rowCount,
        enableColumnFilters: true,
        enableSorting: true,
        enableColumnActions: true,
        // manualPagination: true,
        enableStickyFooter: true,
        state: {
            // columnFilters,
            // globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            showSkeletons: isLoading,
            rowSelection,
        },
        manualFiltering: false,
        manualPagination: true,
        manualSorting: false,
        onPaginationChange: setPagination,
        positionToolbarAlertBanner: "bottom",
        initialState: {
            showColumnFilters: false,
            columnPinning: {
                left: ["STT", "maSp", "transactionNumber", "sourceCode"],
                right: [
                    "statusName",
                    "countSoLuong",
                    "countSlChoXuat",
                    "countSlChoNhap",
                ],
            },
            columnVisibility: { id: false },
            density: "xs",
        },
        enableTopToolbar: false,
        mantineTopToolbarProps: {
            style: {
                borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
                marginBottom: 5,
            },
        },
        localization: _localization,
        getRowId: (row) => row.departmentId,
        mantineTableContainerProps: {
            style: { maxHeight: height, minHeight: height },
        },
        enableStickyHeader: true,
        onRowSelectionChange: setRowSelection,
        mantineTableBodyCellProps: ({ row }) => ({
            style: styleTableMantine,
        }),
        mantineToolbarAlertBannerProps: false
            ? { color: "red", children: "Lỗi tải dữ liệu !" }
            : undefined,

        mantinePaginationProps: {
            showRowsPerPage: true,
            withEdges: true,
            radius: "xl",
            size: "lg",
            rowsPerPageOptions: ["20", "50", "100"],
        },
        paginationDisplayMode: "pages",
        enableColumnPinning: true,
        mantineTableProps: {
            striped: false,
        },
        mantineTableBodyRowProps: ({ row }) => ({
            onClick: row.getToggleSelectedHandler(),
            sx: { cursor: "pointer" },
        }),
    });
    useEffect(() => {
        const headerHeight = headerRef.current?.offsetHeight || 0;
        const handleResize = () => {
            setHeight(window.innerHeight - (165 + headerHeight));
        };

        handleResize(); // Set initial height
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [height]);
    useEffect(() => {
        fetchData();
    }, [pagination]);
    const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
        option,
    }) => (
        <Group gap="sm">
            <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
        </Group>
    );
    // Sử dụng debounce để trì hoãn việc gọi API
    //   const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    //     if (value.length >= 3) {
    //       DataItemCode(value); // Gọi API với từ khóa tìm kiếm
    //     }
    //   }, 500);
    return (
        <Box>
            <LoadingOverlayCustom visible={visible} />
            <div ref={headerRef} style={{ width: "100%", marginBottom: "10px" }}>
                <Flex justify={"space-between"} w={"100%"}>
                    <_breadcrumb></_breadcrumb>
                    <Button
                        leftSection={
                            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                        }
                        onClick={() => exportDataExcel()}
                    >
                        Export Excel
                    </Button>
                </Flex>
                <Grid>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Input
                            placeholder="Nhập tìm kiếm"
                            key={form.key("keySearch")}
                            type="text"
                            leftSection={<IconSearch size={"20"} color="#15aabf" />}
                            onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                    await fetchData();
                                }
                            }}
                            {...form.getInputProps("keySearch")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            key={form.key("MaChung")}
                            placeholder="Nhập mã chủng"
                            data={dataCatSegment4d}
                            leftSection={<IconListDetails color="#15aabf" />}
                            searchable
                            clearable
                            nothingFoundMessage="Không tìm thấy dữ liệu !"
                            {...form.getInputProps("MaChung")}
                            onClick={() => {
                                if (dataCatSegment4d.length === 0) {
                                    getCatSegment4d();
                                }
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            key={form.key("MaNhom")}
                            placeholder="Nhập mã nhóm"
                            data={dataCatSegment5e}
                            leftSection={<IconFolders color="#15aabf" />}
                            searchable
                            clearable
                            {...form.getInputProps("MaNhom")}
                            onClick={() => {
                                getCatSegment5e();
                            }}
                            nothingFoundMessage="Không tìm thấy dữ liệu !"
                        />
                    </Grid.Col>

                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            placeholder="Nhập mã ngành"
                            data={dataCatSegment2b?.map((item) => ({
                                label: item.label,
                                value: item.value,
                            }))}
                            leftSection={<IconBriefcase color="#15aabf" />}
                            searchable
                            clearable
                            {...form.getInputProps("MaNganh")}
                            nothingFoundMessage="Không tìm thấy dữ liệu !"
                            onClick={() => {
                                if (dataCatSegment2b.length === 0) {
                                    fetchDataCatSegment2b();
                                }
                            }}
                        />
                    </Grid.Col>

                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Button
                            color="blue"
                            variant="outline"
                            onClick={async () => {
                                await fetchData();
                            }}
                        >
                            Tìm kiếm
                        </Button>
                    </Grid.Col>
                </Grid>
            </div>
            <MantineReactTable table={table} />
        </Box>
    );
};

export default InventoryAgeItemGroup;
